import { Box, Button, Dialog, Stack } from "@mui/material"
import { styles } from "./styles"
import Image from "mui-image"
import { useTranslation } from "react-i18next"
import { NOTIFICATION_TYPES } from "common/constants"
import { useState } from "react"
import { saveNote } from "utils/sounds"
import { useAuthContext } from "contexts/AuthContext"
import useSound from "use-sound"
import { LANGUAGES_ASSETS } from "../../services/config"

export default function GamesCoin({
  open = false,
  notificationType = NOTIFICATION_TYPES.SMASH_GAME,
  onClose = () => {},
  onStart = () => {},
}) {
  const { audioSettings } = useAuthContext()
  const { t, i18n } = useTranslation()
  const [loadingGame, setLoadingGame] = useState(false)
  const [playSave] = useSound(saveNote, {
    volume: 0.5,
    soundEnabled: audioSettings?.enabledAudioEffects,
    html5: false,
  })

  const startGame = async () => {
    playSave()
    setLoadingGame(true)
    await onStart()
    setTimeout(() => {
      setLoadingGame(false)
    }, 3000)
  }

  return (
    <Dialog
      open={open}
      BackdropProps={{
        sx: {
          backgroundColor: "rgba(0,0,0,.85)",
        },
      }}
      PaperProps={{
        sx: styles.streakModal,
      }}
    >
      <Box onClick={startGame}>
        <Image
          width={320}
          height={320}
          style={{
            ...styles.coinImage,
            ...(loadingGame && styles.flippingCoin),
          }}
          src={
            notificationType === NOTIFICATION_TYPES.SMASH_GAME
              ? `${LANGUAGES_ASSETS}/coins/games/${i18n.language}/join.png`
              : `${LANGUAGES_ASSETS}/coins/independentWork/${i18n.language}/independent-work.png`
          }
        />
      </Box>
      <Stack>
        <Button
          sx={styles.cancelButton}
          disableElevation
          variant="contained"
          onClick={onClose}
        >
          {t("Cancel")}
        </Button>
      </Stack>
    </Dialog>
  )
}
